import Actions from './actionTypes';
import api from '../../services/api';

export const getConfig = () => dispatch => {
  return api.get('/api/config')
    .then(config => {
      dispatch({ type: Actions.CONFIG_FETCHED, payload: config });
    });
};
